import styles from "./index.module.css";
import Line from "../Line/Line";

const LagreLeftLine = () => {
  return (
    <div className={styles.rigthLine}>
      <div className={styles.top}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="365"
          viewBox="0 0 122 365"
          fill="none"
        >
          <path
            d="M0 363.002H112C116.418 363.002 120 359.421 120 355.002V182.252M0 1.50244H112C116.418 1.50244 120 5.08416 120 9.50244V182.252M120 182.252H0"
            stroke="#10C237"
            stroke-width="3"
          />
        </svg>
      </div>
      <div className={styles.lineC}>
        <div className={styles.line} />
        <div className={styles.circkle} />
      </div>

      <div className={styles.bottom}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="122"
          height="218"
          viewBox="0 0 122 218"
          fill="none"
        >
          <path
            d="M120 0.00195312V208.002C120 212.42 116.418 216.002 112 216.002H0"
            stroke="#10C237"
            stroke-width="3"
            stroke-dasharray="6 6"
          />
        </svg>
      </div>
    </div>
  );
};

export default LagreLeftLine;
